/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

export class ResponsiveNavCodes {
  static NAV_LEVEL_1 = 1;
  static NAV_LEVEL_2 = 2;
  static NAV_CLOSE_ALL = 'NAV_CLOSE_ALL';
  static NAV_OPEN = 'NAV_OPEN';
  static NAV_CLOSE = 'NAV_CLOSE';
  static NAV_TOGGLE = 'NAV_TOGGLE';
  static NAV_CLASS_HAMBURGER_MENU = 'open-hamburger-menu';
  static NAV_CLASS_OVERFLOW_MENU = 'open-overflow-menu';
  static NAV_CLASS_TRIGGER_1 = 'header-hamburger-trigger';
  static NAV_CLASS_TRIGGER_2 = 'header-overflow-trigger';
  static NAV_CLASS_LEVEL_1 = 'clr-nav-level-1';
  static NAV_CLASS_LEVEL_2 = 'clr-nav-level-2';
}
